const sharedFontSize = {
  xs: '15px',
  md: '14px',
  lg: '15px',
};

export const sxStyle = {
  siteContainer: {
    zoom: '111.12%',
    minHeight: '100vh',
  },

  principalContainer: {
    width: '90%',
    margin: '4% auto 6% auto',
    padding: '30px 30px 50px 30px',
    boxShadow: '1px 3px 9px 3px rgba(0, 0, 0, 0.15)',
  },

  title: {
    color: 'black',
    fontSize: { xs: '18px', md: '25px' },
    marginBottom: '10px',
    fontWeight: 600,
    lineHeight: 1.5,
  },

  p: {
    fontSize: sharedFontSize,
  },

  link: {
    display: 'block',
    overflowWrap: 'anywhere',
    fontSize: sharedFontSize,
  },

  iconsContainer: {
    mt: { xs: 0, md: '20px' },
    width: {
      xs: '100%',
      md: '70%',
    },
  },

  icon: {
    fontSize: { xs: '42px', md: '50px' },
    color: '#D73242',
    flexShrink: 0,
    alignSelf: { xs: 'flex-start', md: 'center' },
  },
  contactItem: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'flex-start', md: 'flex-start' },
    gap: { xs: '4px', md: '6px' },
    minWidth: 0,
  },

  infoContainer: {
    justifyContent: 'space-between',
    mt: '10px !important',
    mb: { xs: 0, md: '20px' },
  },

  info: {
    width: {
      xs: '100%',
      md: '23%',
    },
  },

  subTitle: {
    color: 'black',
    fontSize: '20px',
    fontWeight: 600,
    m: { xs: 0, md: '12px 19px' },
  },

  list: {
    listStyleType: 'disc',
    paddingLeft: '20px',
    mt: 0,
  },

  listItem: {
    mb: { xs: 0, md: '10px' },
  },
};
